import { serverAjaxPromise } from './request_helpers';

const getHeatmap = opts => {
  return serverAjaxPromise({
    type: 'POST',
    url: '/api/alltrails/maps/heatmap',
    data: opts,
    resReducer: data => data.maps
  });
};

export { getHeatmap };
